import { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { getAnalyzerHandoffWithUrl } from '../../config/api';
import { validateUrl } from '../../utils/urlValidation';
import ScrollReveal from './ScrollReveal';

const FinalCta = () => {
  const [url, setUrl] = useState('');
  const [urlError, setUrlError] = useState('');

  const handleAnalyze = (e) => {
    e.preventDefault();
    setUrlError('');
    const trimmed = url.trim();
    if (!trimmed) {
      setUrlError('Please enter a URL');
      return;
    }
    const v = validateUrl(trimmed);
    if (!v.valid) {
      setUrlError(v.error || 'Please enter a valid URL');
      return;
    }
    window.location.href = getAnalyzerHandoffWithUrl(v.cleanUrl);
  };

  return (
    <section className="py-20 md:py-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <ScrollReveal>
          <div className="relative bg-cv-navy rounded-3xl p-10 md:p-14 text-center shadow-2xl shadow-cv-navy/20 overflow-hidden">

            <div className="relative z-10">
              <h2 className="text-3xl sm:text-4xl font-extrabold text-white mb-4">
                Know Exactly How Bots See Your Website
              </h2>
              <p className="text-white/85 text-lg mb-8 max-w-xl mx-auto">
              Get your Crawler Vision Score in seconds. Free, no signup, and works for JavaScript-heavy sites.
              </p>

              <form onSubmit={handleAnalyze} className="max-w-lg mx-auto mb-4">
                <div className="flex flex-col sm:flex-row gap-3">
                  <input
                    type="url"
                    value={url}
                    onChange={(e) => { setUrl(e.target.value); if (urlError) setUrlError(''); }}
                    placeholder="https://example.com"
                    className={`flex-1 px-5 py-3.5 bg-white/10 backdrop-blur-sm border-2 rounded-xl text-white placeholder:text-white/85 focus:outline-none focus:ring-2 focus:ring-white/50 focus:border-transparent transition-all text-base ${urlError ? 'border-cv-orange/40' : 'border-white/30'}`}
                    aria-label="Website URL to analyze"
                    aria-invalid={!!urlError}
                    aria-describedby={urlError ? 'final-cta-url-error' : undefined}
                  />
                  <button
                    type="submit"
                    className="px-8 py-3.5 bg-white text-cv-navy font-bold rounded-xl hover:bg-cv-sky/10 hover:shadow-xl shadow-lg transition-all flex items-center justify-center gap-2 text-base whitespace-nowrap"
                  >
                    Start Free Analysis <ArrowRight className="w-5 h-5" />
                  </button>
                </div>
                {urlError && (
                  <p id="final-cta-url-error" className="mt-2 text-left text-sm text-cv-gold" role="alert">
                    {urlError}
                  </p>
                )}
              </form>

              <p className="text-white/85 text-sm">
                ✓ Free analysis &nbsp; ✓ No signup required &nbsp; ✓ Works for JavaScript sites
              </p>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default FinalCta;
